import { render } from "./UserTransactions.vue?vue&type=template&id=2a86614c"
import script from "./UserTransactions.vue?vue&type=script&lang=js"
export * from "./UserTransactions.vue?vue&type=script&lang=js"
script.render = render

export default script